import React, { Component } from "react";
import Combobox from 'react-widgets/lib/Combobox'
const isEmpty = require("is-empty");

class FacultyModalComponent extends Component {
	
	state = {
		_id:                "",
		is_active:          "",
		name:               "",
		errorName:          "",
		isValidName:        false,
		description:        "",
		errorDescription:   "",
		isValidDescription: false,
		key:                "",
		errorKey:           "",
		isValidKey:         false,
		rol:		 		"",
		errorRol:          "",
		isValidRol:        false
	}

  	constructor(props) {
		super(props);
		this.onChangeDescription = this.onChangeDescription.bind(this);
		this.preparateCreate     = this.preparateCreate.bind(this);
		this.preparateUpdate     = this.preparateUpdate.bind(this);
		this.onPressCancel       = this.onPressCancel.bind(this);
		this.deactivateFaculty       = this.deactivateFaculty.bind(this);
		this.onChangeName        = this.onChangeName.bind(this);
		this.onChangeRol        = this.onChangeRol.bind(this);
		this.activateFaculty         = this.activateFaculty.bind(this);
		this.escFunction         = this.escFunction.bind(this);
		this.onChangeKey         = this.onChangeKey.bind(this);
	}

	componentDidMount() {
		document.addEventListener("keydown", this.escFunction, false);
	}

	componentDidUpdate(prevProps) {
		if (this.props.modalFacultyData) {
			if (this.props.modalFacultyData !== prevProps.modalFacultyData) {
			
				this.setState({
					_id: this.props.modalFacultyData._id,
					name: this.props.modalFacultyData.name,
					description: this.props.modalFacultyData.description,
					key: this.props.modalFacultyData.key,
					rol: this.props.modalFacultyData.rol,
					is_active: this.props.modalFacultyData.is_active
				})

			}
		}
	}

	///---------------------------------------EVENTS-------------------------------------
	escFunction(event) {
		if (event.keyCode === 27) {
			this.props.onPressCancel();
		}
	}

	async preparateCreate() {
		await this.clearErrors();
		this.validate();
		if (this.state.isValidName && this.state.isValidDescription && this.state.isValidKey && this.state.isValidRol) {
			this.props.createFaculty({
				name:this.state.name,
				description:this.state.description,
				key:this.state.key,
				rol:this.state.rol,
			});
			this.cleanForm();
		}
	}

	async preparateUpdate() {
		await this.clearErrors();
		this.validate();
		if (this.state.isValidName && this.state.isValidDescription && this.state.isValidKey && this.state.isValidRol) {
			this.props.updateFaculty({
				id:this.state._id,
				name:this.state.name,
				description:this.state.description,
				key:this.state.key,
				rol:this.state.rol
			});
			this.cleanForm();
		}
	}

	activateFaculty() {
		this.props.activateFaculty(this.props.modalFacultyData._id);
	}

	deactivateFaculty() {
		this.props.deactivateFaculty(this.props.modalFacultyData._id);
	}

	onPressCancel() {
		this.farmazonFormRef.reset();
		this.setState({
			description: '',
			name: '',
			key: '',
			rol:'',
			errorDescription: '',
			errorName: '',
			errorKey: '',
			errorRol: '',
		}, () => {
			this.props.onPressCancel();
		})
	}

	onChangeName(e) {
		this.setState({
			name: e.target.value,
		})
	}

  	onChangeDescription(e) {
		this.setState({
			description: e.target.value,
		})
	}

  	onChangeKey(e) {
		this.setState({
			key: e.target.value,
		})
	}

	onChangeRol(value) {
		this.setState({
			rol: value._id,
		})
	}

  	clearErrors() {
		this.setState({
			errorDescription: "",
			errorName:        "",
			errorKey:         "",
			errorRol:	""
		})
	}

  	cleanForm() {
		this.farmazonFormRef.reset();
		this.setState({
			description:      "",
			name:             "",
			key:              "",
			errorDescription: "",
			errorName:        "",
			errorKey:         "",
			errorRol: "",
		});
	}

	validate() {
    	if (this.state.name === "" || isEmpty(this.state.name)) {
			this.setState({
				errorName: "El nombre del permiso es requerido."
			})
		} 
		else {
			this.setState({
				isValidName: true
			})
		}

   		if (this.state.description === "" || isEmpty(this.state.description)) {
			this.setState({
				errorDescription: "La descripción del permiso es requerida."
			})
		} 
		else {
			this.setState({
				isValidDescription: true
			})
		}   
    
    	if (this.state.key === "" || isEmpty(this.state.key)) {
			this.setState({
				errorKey: "La clave del permiso es requerida."
			})
		} 
		else {
			this.setState({
				isValidKey: true
			})
		} 

		if (this.state.rol === "" || isEmpty(this.state.rol)) {
			this.setState({
				errorRol: "El rol del permiso es requerido."
			})
		} 
		else {
			this.setState({
				isValidRol: true
			})
		} 
  	}

	///---------------------------------------VIEW-------------------------------------
	render() {
    	var title = "CREACIÓN DE PERMISO";
		if (this.props.type === 'UPDATE') {
			title = "ACTUALIZACIÓN DEL PERMISO";
		}

		let index = 0;
		if(this.props.roles && this.state.rol){
			index = this.props.roles.findIndex(rol => {
				return rol._id === this.state.rol;
			});
		}
		

		return (
			<div className={this.props.isVisible ? "modal display-block" : "modal display-none"}>
				<div className="modal-user-main">
					<div className="auth-group">
						{title}
						<div className="auth-label"></div>
						<div className="auth-label"></div>
						{
							<form ref={(el) => { this.farmazonFormRef = el }}>
							{
								<div className="auth-label">
									Nombre :
									<span className="required"> * </span>
									<input
										id="nameForm"
										onChange={this.onChangeName}
										value={this.state.name || ""}
										error={this.state.errorName}
										type="title"
										placeholder={this.props.modalFacultyData ? this.props.modalFacultyData.name : "Ej.: Centros (Area administrativa)"}
										className="local-store-input"
									/>
								</div>
							}
								<div className="auth-error">{this.state.errorName}</div>
							{
								<div className="auth-label">
									Descripción :
									<span className="required"> * </span>
									<textarea
										id="descriptionForm"
										rows={4}
										onChange={this.onChangeDescription}
										value={this.state.description}
										error={this.state.errorDescription}
										type="title"
										placeholder={this.props.modalFacultyData ? this.props.modalFacultyData.description : "Ej.: Permiso para acceso a area administrativa."}
										className="local-store-text-area"
									/>
								</div>
							}
							<div className="auth-error">{this.state.errorDescription}</div>
							{
								<div className="auth-label">
									Clave :
									<span className="required"> * </span>
									<input
										id="keyForm"
										onChange={this.onChangeKey}
										value={this.state.key}
										error={this.state.errorKey}
										type="title"
										placeholder={this.props.modalFacultyData ? this.props.modalFacultyData.key : "Ej.: CART_CHECKOUT"}
										className="local-store-input"
									/>
								</div>
							}
							{ this.state.rol && this.props.type === 'UPDATE' &&
								<div className="auth-label">
									Rol :
									<span className="required"> * </span>
									<Combobox
										className=""
										data={this.props.roles}
										dataKey='_id'
										textField='name'
										error={this.state.errorRol}
										defaultValue={this.props.roles[index]}
										onChange={this.onChangeRol.bind(this)}
									/>
								</div>
							}
							{ this.props.type === 'CREATE' &&
								<div className="auth-label">
									Rol :
									<span className="required"> * </span>
									<Combobox
										className=""
										data={this.props.roles}
										dataKey='_id'
										textField='name'
										error={this.state.errorRol}
										onChange={this.onChangeRol.bind(this)}
									/>
								</div>
							}
								<div className="auth-error">{this.state.errorRol}</div>
								<div className="auth-error">{this.state.errorKey}</div>
								<div className="auth-label"></div>
								<div className="auth-label"></div>
								<div className="auth-error">{this.props.error}</div>
							</form>
						}

						<div className="modal-activity-section">
						{
							this.props.type === 'UPDATE' &&
							<button className="modal-buttonOK" onClick={this.preparateUpdate}>ACTUALIZAR</button>
						}
						{
							this.props.type !== 'UPDATE' &&
							<button className="modal-buttonOK" onClick={this.preparateCreate}>GUARDAR</button>
						}
						{
							this.props.type === 'UPDATE' &&
							this.props.modalFacultyData &&
							this.props.modalFacultyData.is_active === false &&
							<button className="modal-buttonActivate" onClick={this.activateFaculty}>ACTIVAR</button>
						}
						{
							this.props.type === 'UPDATE' &&
							this.props.modalFacultyData &&
							this.props.modalFacultyData.is_active &&
							<button className="modal-buttonDelete" onClick={this.deactivateFaculty}>DESACTIVAR</button>
						}
						{
							<button className="modal-buttonNo" onClick={this.onPressCancel}>CERRAR</button>
						}
						</div>
					</div>
				</div>
			</div>
		);
  	}

}

export default FacultyModalComponent;